import { render, staticRenderFns } from "./ForgotPasswordUpdatePassword.vue?vue&type=template&id=151f5332&scoped=true&"
import script from "./ForgotPasswordUpdatePassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordUpdatePassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordUpdatePassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ForgotPasswordUpdatePassword.vue?vue&type=style&index=1&id=151f5332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151f5332",
  null
  
)

export default component.exports